(function() {
  'use strict';
  
  // Get block ID from the script tag's data attribute
  const scriptTag = document.currentScript;
  const blockId = scriptTag.getAttribute('data-block-id');
  const blockIdSafe = blockId.replace(/-/g, '_');
  
  const optionsWrapper = document.querySelector( `.riot-configurator-block[data-block-id="${blockId}"]` );
  const options        = optionsWrapper.querySelectorAll(`fieldset.option-selector-${blockId}`);
  const config         = {};

  options.forEach( function( option )
  {
    var optionName   = option.dataset.optionName;
    var defaultInput = option.querySelector( `input[name=${optionName}-${blockId}]:checked` );
    var defaultValue = defaultInput.value;
    config[ optionName ] = defaultValue;
  });
  
  const variantsJSON = window['riotVariants_' + blockIdSafe];

  var activeVariants = [];

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  
  function init()
  {
    enableAllLabels();
    attachEventListeners();
    applyConditionalLogic();
    syncAttachmentAvailability()
    updateConfiguration();
    initAttachmentWiring();
  }

  function initAttachmentWiring()
  {
    var attachmentOpts = [
      'dip-horn_configurator',
      'dip-bars_configurator',
      'mrr-landmine_configurator',
      'monolifts_configurator',
      'single-bar-holder_configurator'
    ];
    var checkboxes = optionsWrapper.querySelectorAll( '#attachments-options-' + blockId + ' input[type="checkbox"]' );
    checkboxes.forEach( function( cb )
    {
      cb.addEventListener( 'change', function()
      {
        var optName = cb.dataset.option;
        var value   = cb.checked ? 'yes' : 'no';
        var radio   = document.getElementById( optName + '-' + value + '-' + blockId );
        if( radio )
        {
          radio.checked = true;
          radio.dispatchEvent( new Event( 'change', { bubbles: true } ) );
        }
      });
    });
  }
  
  function enableAllLabels()
  {
    var labels = document.querySelectorAll(`label[data-block="${blockId}"].opt-label`);
    labels.forEach( function( label )
    {
      label.removeAttribute( "disabled" );
    });
  }

  function attachEventListeners() {
    var inputs = document.querySelectorAll(`input[data-block="${blockId}"].opt-btn`);
    inputs.forEach( function( input )
    {
      input.addEventListener('change', handleOptionChange);
    });
    
    const addToCartBtn = document.getElementById(`add-to-cart-btn-${blockId}`);
    if( addToCartBtn )
    {
      addToCartBtn.addEventListener('click', addToCart);
    }
  }
  
  function handleOptionChange( e )
  {
    const input     = e.currentTarget;
    const option    = input.dataset.option;
    const value     = input.value;
    const configKey = option.replace( /-([a-z])/g, (g) => g[1].toUpperCase() );
    
    config[ configKey ] = value;

    console.log(config);
    
    applyConditionalLogic( option, value );
    updateConfiguration();
  }
  
  function updateConfiguration() {
    updateHiddenInputs();
    updateAvailableSelectors();
    syncAttachmentAvailability();
    updateSKUs();
    updatePrice();
    updateSummary();
  }

  function ApplyMatchLabelConditions( input )
  {
    var matchConditions = input.getAttribute( "match-conditions" );
    if( matchConditions && matchConditions != "" )
    {
      var allMatch = false;
      matchConditions = matchConditions.split( "," );
      for( var idx in matchConditions )
      {
        var matchInput = optionsWrapper.querySelector( `input[data-block="${blockId}"].opt-btn[hide-label-identifier="${matchConditions[ idx ]}"]` );
        if( matchInput.checked == false )
        {
          allMatch = false;
          break;
        }
        else
        {
          allMatch = true;
        }
      }
      if( allMatch )
      {
        input.checked = true;
        var labelParent = input.closest( `fieldset.option-selector-${blockId}` );
        if( labelParent )
        {
          var matchInputs = labelParent.querySelectorAll( `input[data-block="${blockId}"].opt-btn` );
          matchInputs.forEach( function( matchCheckInput )
          {
            if( matchCheckInput != input )
            {
              var matchCheckLabel = optionsWrapper.querySelector( `label[data-block="${blockId}"].opt-label[for="${matchCheckInput.id}"]` );
              matchCheckLabel.setAttribute( "style", "display:none;" );
              matchCheckLabel.setAttribute( "label-hidden", "" );
            }
          });
        }
      }
    }
  }

  function ApplyHideLabelConditions( input )
  {
    var disableLabels = input.getAttribute( "disable-labels" );
    if( disableLabels && disableLabels != "" )
    {
      disableLabels = disableLabels.split( "," );
      for( var idx in disableLabels )
      {
        var hideInput = optionsWrapper.querySelector( `input[data-block="${blockId}"].opt-btn[hide-label-identifier="${disableLabels[ idx ]}"]` );
        if( hideInput )
        {
          var hideLabel = optionsWrapper.querySelector( `label[data-block="${blockId}"].opt-label[for="${hideInput.id}"]` );
          hideLabel.setAttribute( "style", "display:none;" );
          hideLabel.setAttribute( "label-hidden", "" );
          var labelParent = hideLabel.closest( `fieldset.option-selector-${blockId}` );
          if( labelParent )
          {
            var selectedInput = labelParent.querySelector( `input[data-block="${blockId}"].opt-btn:checked` );
            if( selectedInput )
            {
              var selectedLabel = labelParent.querySelector( `label[data-block="${blockId}"].opt-label[for="${selectedInput.id}"]` );
              if( selectedLabel == hideLabel )
              {
                var firstAvailableLabel = labelParent.querySelector( `label[data-block="${blockId}"].opt-label:not([label-hidden])` );
                if( firstAvailableLabel )
                {
                  var firstAvailableInput = labelParent.querySelector( `input[data-block="${blockId}"].opt-btn#${firstAvailableLabel.getAttribute( "for" )}`)
                  if( firstAvailableInput )
                  {
                    firstAvailableInput.checked = true;
                  }
                }
              }
            }
            if( !labelParent.querySelector( `label[data-block="${blockId}"].opt-label:not([label-hidden])` ) )
            {
              labelParent.setAttribute( "style", "display:none;" );
              labelParent.setAttribute( "option-hidden", "" );
            }
          }
        }
      }
    }
  }

  function ApplyConditionalQuantities( input )
  {
    var reduceQuantities = input.getAttribute( "reduce-quantities" );
    var inputQuantity    = input.getAttribute( "quantity" );
    if( reduceQuantities && reduceQuantities != "" )
    {
      reduceQuantities = reduceQuantities.split( "," );
      for( var idx in reduceQuantities )
      {
        var reduceQuantityInput = optionsWrapper.querySelector( `input[data-block="${blockId}"].opt-btn[hide-label-identifier="${reduceQuantities[ idx ]}"]` );
        if( reduceQuantityInput )
        {
          var newQuantity = Number( reduceQuantityInput.getAttribute( "quantity" ) ) - ( Number( inputQuantity ) );
          if( newQuantity <= 0 )
          {
            newQuantity = 0;
          }

          reduceQuantityInput.setAttribute( "quantity", newQuantity );
        }
      }
    }
  }

  function applyConditionalLogic( option, value )
  {
    if( option && ( option == 'storage' ) )
    {
      var storageOptions = document.getElementById(`storage-options-${blockId}`);
      if( storageOptions )
      {
        if( value == "Yes" )
        {
          storageOptions.setAttribute( "style", "display:block;" );
        }
        else
        {
          storageOptions.setAttribute( "style", "display:none;" );
          // Reset branded crossmember to No when storage is turned off
          var nameplateNoInput = document.getElementById(`nameplate-weight-no-${blockId}`);
          if( nameplateNoInput )
          {
            nameplateNoInput.checked = true;
            nameplateNoInput.dispatchEvent( new Event( 'change', { bubbles: true } ) );
          }
          var nameplateHidden = document.getElementById(`hidden-nameplate-weight-${blockId}`);
          if( nameplateHidden ) nameplateHidden.value = 'No';
        }
      }
    }
    if( option && ( option == 'nameplate-weight' ) )
    {
      var nameplateHidden = document.getElementById(`hidden-nameplate-weight-${blockId}`);
      if( nameplateHidden ) nameplateHidden.value = value;
    }
    options.forEach( function( option )
    {
      if( option.hasAttribute( "option-hidden" ) )
      {
        option.setAttribute( "style", "" );
        option.removeAttribute( "option-hidden" );
      }
      var allINputs = option.querySelectorAll( `input[data-block="${blockId}"].opt-btn` );
      allINputs.forEach( function( input )
      {
        input.setAttribute( "quantity", input.getAttribute( "original-quantity" ) );
        var label = document.querySelector( `label[for="${input.id}"]` );
        label.setAttribute( "style", "" );
        if( label.hasAttribute( "label-hidden" ) )
        {
          label.removeAttribute( "label-hidden" );
        }
      });
    });
    
    options.forEach( function( option )
    {
      var inputs    = option.querySelectorAll( `input[data-block="${blockId}"].opt-btn` );
      inputs.forEach( function( input )
      {
        ApplyMatchLabelConditions( input );
      });
      inputs.forEach( function( input )
      {
        if( input.checked )
        {
          ApplyHideLabelConditions( input );
        }
      });
      inputs.forEach( function( input )
      {
        if( input.checked )
        {
          ApplyConditionalQuantities( input );
        }
      });
    });
  }
  
  function updateHiddenInputs()
  {
    Object.keys(config).forEach(function( key )
    {
      const input = document.getElementById( `hidden-${key}-${blockId}` );
      if( input ) input.value = config[ key ];
    });
  }
  
    function isVariantAvailable(variantId, qty) {
  qty = Number(qty || 1);

  // No variant means this is a UI/control option, not stock-tracked
  if (!variantId) return true;

  var variant = variantsJSON[variantId];

  // If this variant is not in variantsJSON, don't disable the option
  // unless you explicitly want unknown variants to be blocked
  if (!variant) return true;

  if (variant.available === false) return false;
  if (Number(variant.inventory_quantity) < qty) return false;

  return true;
}

  function setInputAvailability( input, isAvailable )
  {
    if( !input ) return;

    var label = optionsWrapper.querySelector( `label[for="${input.id}"]` );
    if( !label ) return;

    // A button is clickable ONLY when its current combination is available.
    // When the current combo is sold out we hard-disable it (not clickable),
    // matching the theme's convention: the input carries the `is-unavailable`
    // class + `disabled`/`unavailable`, and the label gets a `title="Sold out"`
    // tooltip. Theme CSS styles the swatch via `.is-unavailable + .opt-label`.
    if( isAvailable )
    {
      input.removeAttribute( "disabled" );
      input.removeAttribute( "unavailable" );
      input.classList.remove( "is-unavailable" );
      input.setAttribute( "available", "" );
      label.removeAttribute( "title" );
      label.style.opacity = "";
    }
    else
    {
      input.setAttribute( "disabled", "" );
      input.setAttribute( "unavailable", "" );
      input.classList.add( "is-unavailable" );
      input.removeAttribute( "available" );
      label.setAttribute( "title", "Sold out" );
      label.style.opacity = "";
    }
  }

  function resolveTargetVariant(selectedInput, option) {
  if (!selectedInput || !option) return null;

  // Start from every variant this input participates in.
  var candidates = (selectedInput.getAttribute("variants") || "")
    .split(",")
    .map(function(v) { return v.trim(); })
    .filter(Boolean);

  if (candidates.length === 0) return null;
  if (candidates.length === 1) return candidates[0];

  var parent = option.closest(".options-container");
  if (!parent) return candidates[0];

  // Narrow the candidate variants down by intersecting with the variant list
  // of every OTHER currently-checked option in this container (height, depth,
  // color, …). A variant ID belongs to exactly one value of each dimension, so
  // intersecting across all checked dimensions resolves the exact current combo
  // — e.g. Black ∩ 2100 ∩ 725 → the single Black-2100-725 variant.
  //
  // This is intentionally direction-agnostic: it does NOT rely on `secondary-for`
  // (which is only populated one way), so it resolves correctly whether we're
  // evaluating the primary height option or a secondary colour/depth option.
  var siblingOptions = parent.querySelectorAll(`fieldset.option-selector-${blockId}`);

  for (var s = 0; s < siblingOptions.length; s++) {
    var siblingOption = siblingOptions[s];
    if (siblingOption === option) continue;

    var siblingName = siblingOption.dataset.optionName;
    var siblingInput = siblingOption.querySelector(`input[name=${siblingName}-${blockId}]:checked`);
    if (!siblingInput) continue;

    var siblingVariants = (siblingInput.getAttribute("variants") || "")
      .split(",")
      .map(function(v) { return v.trim(); })
      .filter(Boolean);

    // Skip control options that aren't variant-backed.
    if (siblingVariants.length === 0) continue;

    var narrowed = candidates.filter(function(vid) {
      return siblingVariants.indexOf(vid) !== -1;
    });

    // Only apply the intersection when this sibling actually shares the variant
    // space (a real dimension of this product). Unrelated options never overlap,
    // so they leave the candidate set untouched instead of zeroing it out.
    if (narrowed.length > 0) {
      candidates = narrowed;
      if (candidates.length === 1) break;
    }
  }

  return candidates[0] || null;
}

  function getSelectedOptionState( option )
  {
    if( !option ) return null;

    var optionName = option.dataset.optionName;
    var selectedInput = option.querySelector( `input[name=${optionName}-${blockId}]:checked` );
    if( !selectedInput ) return null;

    var inputQuantity = Number( selectedInput.getAttribute( "quantity" ) || 0 );
    var targetVariantId = resolveTargetVariant( selectedInput, option );
    var variant = targetVariantId ? variantsJSON[ targetVariantId ] : null;

    return {
      optionName: optionName,
      selectedInput: selectedInput,
      quantity: inputQuantity,
      variantId: targetVariantId,
      variant: variant
    };
  }

  function getAttachmentState( optName )
  {
    var checkbox = optionsWrapper.querySelector( `#attachments-options-${blockId} input[type="checkbox"][data-option="${optName}"]` );
    var yesRadio = document.getElementById( optName + '-yes-' + blockId );
    var noRadio  = document.getElementById( optName + '-no-' + blockId );

    if( !checkbox || !yesRadio ) return null;

    var variantId = yesRadio.getAttribute( 'variants' );
    var quantity = 1;

    return {
      checkbox: checkbox,
      yesRadio: yesRadio,
      noRadio: noRadio,
      variantId: variantId,
      quantity: quantity,
      variant: variantsJSON[ variantId ] || null,
      available: isVariantAvailable( variantId, quantity )
    };
  }

  function syncAttachmentAvailability()
{
  var ATTACHMENT_OPTIONS = [
    'dip-horn_configurator',
    'dip-bars_configurator',
    'mrr-landmine_configurator',
    'monolifts_configurator',
    'single-bar-holder_configurator'
  ];

  ATTACHMENT_OPTIONS.forEach( function( optName )
  {
    var state = getAttachmentState( optName );
    if( !state ) return;

    var label = optionsWrapper.querySelector( `label[for="${state.checkbox.id}"]` );

    if( state.available )
    {
      state.checkbox.disabled = false;
      state.checkbox.removeAttribute( 'unavailable' );
      state.checkbox.setAttribute( 'available', '' );

      if( label ) label.style.opacity = '';
    }
    else
    {
      state.checkbox.checked = false;
      state.checkbox.disabled = true;
      state.checkbox.removeAttribute( 'available' );
      state.checkbox.setAttribute( 'unavailable', '' );

      if( state.noRadio ) state.noRadio.checked = true;
      if( label ) label.style.opacity = '0.5';
    }
  });
}

      function updateAvailableSelectors() {
  options.forEach(function(option) {
    var optionName = option.dataset.optionName;
    var optionInputs = option.querySelectorAll(`input[name=${optionName}-${blockId}]`);

    optionInputs.forEach(function(optionInput) {
      var qty = Number(optionInput.getAttribute("quantity") || 0);
      var targetVariantId = resolveTargetVariant(optionInput, option);

      // No real variant behind this option (e.g. "None")? Leave it enabled.
      if (!targetVariantId) {
        setInputAvailability(optionInput, true);
        return;
      }

      // Clickable only when THIS value's current combination is in stock.
      var available = isVariantAvailable(targetVariantId, qty);
      setInputAvailability(optionInput, available);
    });

    // If the currently-selected value is now unavailable (its combo is sold
    // out), bump the selection to the first available value in this option so
    // the configuration never rests on a disabled/invalid selection.
    var selectedInput = option.querySelector(`input[name=${optionName}-${blockId}]:checked`);
    if (selectedInput && selectedInput.hasAttribute("unavailable")) {
      var fallback = option.querySelector(`input[name=${optionName}-${blockId}][available]`);
      if (fallback) {
        fallback.click();
      }
    }
  });
}

    function updateSKUs()
  {
    activeVariants = [];

    options.forEach( function( option )
    {
      var skuDisplay = option.querySelector( ".sku-display" );
      var state = getSelectedOptionState( option );

      if( !state || !state.selectedInput ) return;

      var selectedInput = state.selectedInput;
      var inputQuantity = state.quantity;
      var targetVariantId = state.variantId;
      var variant = state.variant;

      if( skuDisplay )
      {
        if(
          selectedInput.getAttribute( "secondary-for" ) != "" &&
          selectedInput.getAttribute( "secondary-for" ).split( "," ).length > 0
        )
        {
          skuDisplay.setAttribute( "style", "display:none;" );
        }
        else
        {
          skuDisplay.setAttribute( "style", "display:inline-block;" );
        }

        if( variant )
        {
          skuDisplay.textContent = `${inputQuantity}x ${variant.sku || variant.id}`;
        }
        else if( targetVariantId )
        {
          skuDisplay.textContent = "Variant Not Found";
        }
        else
        {
          skuDisplay.textContent = selectedInput.value;
        }
      }

      var optionVisible =
        option.hasAttribute( "option-hidden" ) == false &&
        (
          option.hasAttribute( "data-storage" ) == false ||
          (
            option.hasAttribute( "data-storage" ) &&
            document.querySelector(`fieldset.option-selector-${blockId}[data-option-name="storage"] input#storage-yes-${blockId}:checked`)
          )
        );

      if( optionVisible && variant && isVariantAvailable( targetVariantId, inputQuantity ) && inputQuantity > 0 )
      {
        if( activeVariants[ variant.id ] )
        {
          activeVariants[ variant.id ] = Number( activeVariants[ variant.id ] ) + Number( inputQuantity );
        }
        else
        {
          activeVariants[ variant.id ] = Number( inputQuantity );
        }
      }
    });

    // Branded crossmember shared SKU
var NAMEPLATE_VARIANT_ID = '55424688816393';

function addActiveVariant(variantId, quantity) {
  quantity = Number(quantity || 1);

  if (!variantId || quantity <= 0) return;
  if (!isVariantAvailable(variantId, quantity)) return;

  activeVariants[variantId] =
    Number(activeVariants[variantId] || 0) + quantity;
}

// Safety check: if the main rack branded crossmember is selected,
// make sure it is included even if the normal option loop missed it.
var selectedMainNameplate = Array.from(
  optionsWrapper.querySelectorAll(`input[data-block="${blockId}"].opt-btn:checked[variants]`)
).find(function(input) {
  if (input.id === `nameplate-weight-yes-${blockId}`) return false;

  var variants = (input.getAttribute('variants') || '')
    .split(',')
    .map(function(v) { return v.trim(); });

  return variants.indexOf(NAMEPLATE_VARIANT_ID) !== -1;
});

if (
  selectedMainNameplate &&
  !activeVariants[NAMEPLATE_VARIANT_ID]
) {
  addActiveVariant(
    NAMEPLATE_VARIANT_ID,
    selectedMainNameplate.getAttribute('quantity') || 1
  );
}

// Weight storage extension branded crossmember.
// This uses the same SKU, so it must ADD to the existing quantity,
// never overwrite or delete it.
var storageIsYes = !!optionsWrapper.querySelector(`#storage-yes-${blockId}:checked`);
var extensionNameplateYes = document.getElementById(`nameplate-weight-yes-${blockId}`);

if (
  storageIsYes &&
  extensionNameplateYes &&
  extensionNameplateYes.checked
) {
  addActiveVariant(NAMEPLATE_VARIANT_ID, 1);
}

    // Attachments
    var ATTACHMENT_OPTIONS = [
      'dip-horn_configurator',
      'dip-bars_configurator',
      'mrr-landmine_configurator',
      'monolifts_configurator',
      'single-bar-holder_configurator'
    ];

    ATTACHMENT_OPTIONS.forEach( function( optName )
    {
      var state = getAttachmentState( optName );
      if( !state ) return;

      if( state.checkbox.checked && state.available )
      {
        activeVariants[ state.variantId ] = state.quantity;
      }
      else
      {
        delete activeVariants[ state.variantId ];
      }
    });
  }

function getAllItems() {
  const items = [];
  
  var targetVariant;
  for( var activeVariant in activeVariants )
  {
    if( variantsJSON[ activeVariant ] )
    {
      targetVariant = variantsJSON[ activeVariant ];
      const priceWithoutVAT = targetVariant.price / 100; // Original net price per item
      
      // Apply discount and round per item (Shopify method)
      const discountedWithoutVAT = Math.round(priceWithoutVAT * 0.90 * 100) / 100;
      
      items.push( { 
        id: targetVariant.id, 
        qty: activeVariants[ activeVariant ], 
        priceExclVAT: discountedWithoutVAT, // Rounded discounted price excl VAT
        originalPrice: priceWithoutVAT,
        name: targetVariant.sku, 
        title: targetVariant.product_title || targetVariant.name || targetVariant.title || targetVariant.sku  
      });
    }
  }

  return items;
}

function updatePrice() {
  const items = getAllItems();

  // Original total (net, before discount)
  const totalNet = items.reduce((sum, item) => sum + (item.originalPrice * item.qty), 0);

  // Discounted total (net) - you already round per item in getAllItems()
  const discountedNet = items.reduce((sum, item) => sum + (item.priceExclVAT * item.qty), 0);

  console.log('=== TOTALS ===');
  console.log('Original total (net):', totalNet.toFixed(2), '€');
  console.log('Discounted total (net):', discountedNet.toFixed(2), '€');

  const priceEl = document.getElementById(`total-price-${blockId}`);
  if (priceEl) {
    priceEl.textContent = `€${totalNet.toFixed(2)}`;
  }

  const discountedPriceEl = document.getElementById(`total-price-discounted-${blockId}`);
  if (discountedPriceEl) {
    discountedPriceEl.textContent = `€${discountedNet.toFixed(2)}`;
  }

  const priceWithoutVATEl = document.getElementById(`total-price-excl-vat-${blockId}`);
  if (priceWithoutVATEl) {
    // Optional: keep this line, or remove if you don’t want any VAT wording at all
    const discountedGross = discountedNet;          // <-- your discounted total as currently displayed (VAT included)
    const discountedExclVAT = discountedGross / 1.19;

    priceWithoutVATEl.textContent = `€${discountedExclVAT.toFixed(2)} Excl. VAT`;
  }
}
  
function updateSummary() {
  const items = getAllItems();
  const summaryEl = document.getElementById(`summary-items-${blockId}`);
  
  if (summaryEl) {
    summaryEl.innerHTML = items.map(item => {
      let displayTitle = item.title;

      // Add "(Pair)" for specific products
      const pairProducts = [
        "Riot MRR 75 | Uprights",
        "Riot MRR 75 | Crossmembers",
        "Riot MRR 75 | Feet"
      ];

      if (pairProducts.some(name => displayTitle.includes(name))) {
        displayTitle += " (Pair)";
      }

      const lineTotal = item.priceExclVAT * item.qty;
      return `<div class="riot-summary-item">${item.qty}x ${displayTitle} - €${lineTotal.toFixed(2)}</div>`;
    }).join('');
  }
}
  
  async function addToCart() {
    const btn = document.getElementById(`add-to-cart-btn-${blockId}`);
    const messageEl = document.getElementById(`riot-config-cart-message`);
    
    if (!btn || !messageEl) return;
    
    btn.disabled = true;
    btn.textContent = 'Adding...';
    messageEl.textContent = '';
    
    const items = getAllItems().map(item => ({
      id: item.id,
      quantity: item.qty
    }));

    const unavailableItems = items.filter(function(item) {
      return !isVariantAvailable(item.id, item.quantity);
    });

    if (unavailableItems.length) {
      messageEl.textContent = 'Some selected items are out of stock. Please review your configuration.';
      messageEl.style.color = 'red';
      btn.disabled = false;
      btn.textContent = 'Add to Cart';
      updateConfiguration();
      return;
    }
    
    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items })
      });
      
      if (!response.ok) throw new Error('Failed to add to cart');
      
      messageEl.textContent = '✓ Successfully added to cart!';
      messageEl.style.color = 'green';
      
      /* setTimeout(() => {
        window.location.href = '/cart';
      }, 1000); */

      setTimeout(() => {
        messageEl.textContent = '';
        messageEl.style.color = '';
        btn.disabled = false;
        btn.textContent = 'Add to Cart';
      }, 2000);

      // Refresh drawer contents + open drawer
document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh'));
setTimeout(() => {
  document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open', {
    detail: { opener: btn }
  }));
}, 0);
      
    } catch (error) {
      console.error('Cart error:', error);
      messageEl.textContent = 'Error adding to cart. Please try again.';
      messageEl.style.color = 'red';
      btn.disabled = false;
      btn.textContent = 'Add to Cart';
    }
  }
  
})();

// Update color text for color swatches (borrowed from variant-picker.js)
document.addEventListener('change', function(e) {
  if (e.target.classList.contains('opt-btn')) {
    const selector = e.target.closest('.option-selector');
    if (!selector) return;
    
    const colorText = selector.querySelector('.js-color-text');
    if (!colorText) return;
    
    const valueSpan = e.target.nextElementSibling.querySelector('.js-value');
    if (valueSpan) {
      colorText.textContent = valueSpan.textContent;
    }
  }
});

// Initialize on page load
document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.riot-configurator-block .opt-btn:checked').forEach(function(radio) {
    const selector = radio.closest('.option-selector');
    if (!selector) return;
    
    const colorText = selector.querySelector('.js-color-text');
    if (!colorText) return;
    
    const valueSpan = radio.nextElementSibling.querySelector('.js-value');
    if (valueSpan) {
      colorText.textContent = valueSpan.textContent;
    }
  });
});

// Show toggle on canvas

(function() {
    const canvasZone = document.getElementById('bitbybit-canvas-zone-AN1poUXNPNHFERmJVW__3d_bits_bitbybit_viewer_ejVzzE');
    
    if (!canvasZone) {
        console.error('Canvas zone not found');
        return;
    }
    
    canvasZone.style.position = 'relative';
    
    const style = document.createElement('style');
    style.textContent = `
        .toggle-container {
            position: absolute;
            bottom: 20px;
            left: 20px;
            background: rgba(245, 245, 245);
            backdrop-filter: blur(10px);
            padding: 14px;
            border-radius: 5px;
            box-shadow: 0 2px 12px rgba(0, 0, 0, 0.15);
            min-width: 250px;
            z-index: 5;
        }
        .toggle-group {
            display: flex;
            flex-direction: column;
            gap: 16px;
        }
        .toggle-item {
            display: flex;
            align-items: center;
            justify-content: space-between;
            gap: 16px;
        }
        .toggle-label {
            font-size: 15px;
            font-weight: 500;
            color: #333;
            user-select: none;
            cursor: pointer;
        }
        .toggle-input {
            position: absolute;
            opacity: 0;
            width: 0;
            height: 0;
        }
        .toggle-switch {
            position: relative;
            display: inline-block;
            width: 50px;
            height: 28px;
            background-color: #ccc;
            border-radius: 28px;
            cursor: pointer;
            transition: background-color 0.3s ease;
        }
        .toggle-switch::before {
            content: '';
            position: absolute;
            width: 22px;
            height: 22px;
            border-radius: 50%;
            background-color: white;
            top: 3px;
            left: 3px;
            transition: transform 0.3s ease;
            box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
        }
        .toggle-input:checked + .toggle-switch {
            background-color: rgb(148, 20, 10);
        }
        .toggle-input:checked + .toggle-switch::before {
            transform: translateX(22px);
        }
        .toggle-switch:hover {
            opacity: 0.9;
        }
        .toggle-input:focus + .toggle-switch {
            outline: 2px solid rgb(148, 20, 10);
            outline-offset: 2px;
        }

        /* Mobile styles */
        @media (max-width: 768px) {
            .toggle-container {
                background: rgba(245, 245, 245, 0.7);
                bottom: 20px;
                left: 12px;
                padding: 12px;
                min-width: 180px;
                border-radius: 6px;
            }

            .toggle-group {
                gap: 10px;
            }

            .toggle-item {
                gap: 10px;
            }

            .toggle-label {
                font-size: 13px;
            }

            .toggle-switch {
                width: 40px;
                height: 22px;
                border-radius: 22px;
            }

            .toggle-switch::before {
                width: 16px;
                height: 16px;
                top: 3px;
                left: 3px;
            }

            .toggle-input:checked + .toggle-switch::before {
                transform: translateX(18px);
            }
        }

        /* Extra small mobile */
        @media (max-width: 480px) {
            .toggle-container {
                bottom: 20px;
                left: 5px;
                padding: 10px;
                min-width: 160px;
            }

            .toggle-group {
                gap: 8px;
            }

            .toggle-item {
                gap: 8px;
            }

            .toggle-label {
                font-size: 12px;
            }

            .toggle-switch {
                width: 36px;
                height: 20px;
            }

            .toggle-switch::before {
                width: 14px;
                height: 14px;
            }

            .toggle-input:checked + .toggle-switch::before {
                transform: translateX(16px);
            }
        }



    `;
    document.head.appendChild(style);
    
    const toggleContainer = document.createElement('div');
    toggleContainer.className = 'toggle-container';
    toggleContainer.innerHTML = `
        <div class="toggle-group">
            <div class="toggle-item">
                <label for="dimensions-toggle" class="toggle-label">Dimensions</label>
                <input 
                    type="radio" 
                    id="dimensions-toggle" 
                    name="Dimensions-xlqlwc"
                    class="toggle-input"
                    value="Hide"
                >
                <label for="dimensions-toggle" class="toggle-switch"></label>
            </div>
        </div>
    `;
    
    canvasZone.appendChild(toggleContainer);
    
    const dimensionsToggle = document.querySelector('input[name="Dimensions-xlqlwc"]');
  
    
    // Store previous state
    let dimensionsWasChecked = false;
  
    
    dimensionsToggle.addEventListener('click', function(e) {
        // Check if it was already checked before this click
        if (dimensionsWasChecked) {
            // Was ON, turn it OFF
            setTimeout(() => {
                this.checked = false;
                this.value = 'Hide';
                this.removeAttribute('checked');
                dimensionsWasChecked = false;
                console.log('Dimensions toggle: OFF, value:', this.value);
            }, 0);
        } else {
            // Was OFF, turn it ON
            this.value = 'Show';
            this.setAttribute('checked', '');
            dimensionsWasChecked = true;
            console.log('Dimensions toggle: ON, value:', this.value);
        }
    });
    
})();

// Height-Color Restriction Logic (applies to both main color and storage color)
(function() {
  function initHeightColorRestriction() {
    const scriptTag = document.currentScript;
    if (!scriptTag) return;
    
    const blockId = scriptTag.getAttribute('data-block-id');
    if (!blockId) return;
    
    const optionsWrapper = document.querySelector(`.riot-configurator-block[data-block-id="${blockId}"]`);
    if (!optionsWrapper) return;

    // Function to apply color restriction based on current height
    function applyColorRestriction() {
      const checkedHeight = optionsWrapper.querySelector(`input[data-option="height"][data-block="${blockId}"]:checked`);
      if (!checkedHeight) return;
      
      const selectedHeight = checkedHeight.value;
      
      // Handle both main color and storage color selectors
      const colorFieldset = optionsWrapper.querySelector(`fieldset.option-selector-${blockId}[data-option-name="color"]`);
      const storageColorFieldset = optionsWrapper.querySelector(`fieldset.option-selector-${blockId}[data-option-name="storage-color"]`);
      
      const fieldsets = [colorFieldset, storageColorFieldset].filter(f => f);
      
      fieldsets.forEach(function(fieldset) {
        const allColorInputs = fieldset.querySelectorAll(`input[data-block="${blockId}"].opt-btn`);
        const blackColorInput = fieldset.querySelector(`input[data-block="${blockId}"].opt-btn[value="Black"]`);
        
        if (selectedHeight === '1800') {
          // Hide all colors except Black
          allColorInputs.forEach(function(colorInput) {
            const colorLabel = optionsWrapper.querySelector(`label[data-block="${blockId}"].opt-label[for="${colorInput.id}"]`);
            if (colorInput.value !== 'Black') {
              colorLabel.setAttribute("style", "display:none;");
              colorLabel.setAttribute("label-hidden", "");
            } else {
              colorLabel.setAttribute("style", "");
              colorLabel.removeAttribute("label-hidden");
            }
          });
          
          // Select Black color
          if (blackColorInput && !blackColorInput.checked) {
            blackColorInput.checked = true;
            blackColorInput.dispatchEvent(new Event('change', { bubbles: true }));
          }
        } else {
          // Show all colors
          allColorInputs.forEach(function(colorInput) {
            const colorLabel = optionsWrapper.querySelector(`label[data-block="${blockId}"].opt-label[for="${colorInput.id}"]`);
            colorLabel.setAttribute("style", "");
            if (colorLabel.hasAttribute("label-hidden")) {
              colorLabel.removeAttribute("label-hidden");
            }
          });
        }
      });
    }

    // Listen for height changes
    const heightInputs = optionsWrapper.querySelectorAll(`input[data-option="height"][data-block="${blockId}"]`);
    heightInputs.forEach(function(heightInput) {
      heightInput.addEventListener('change', applyColorRestriction);
    });
    
    // Listen for storage toggle (Yes/No)
    const storageInputs = optionsWrapper.querySelectorAll(`input[data-option="storage"][data-block="${blockId}"]`);
    storageInputs.forEach(function(storageInput) {
      storageInput.addEventListener('change', function() {
        // Wait a bit for the storage color selector to appear in the DOM
        setTimeout(applyColorRestriction, 100);
      });
    });
    
    // Check initial state
    const checkedHeight = optionsWrapper.querySelector(`input[data-option="height"][data-block="${blockId}"]:checked`);
    if (checkedHeight && checkedHeight.value === '1800') {
      applyColorRestriction();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHeightColorRestriction);
  } else {
    initHeightColorRestriction();
  }
})();

// Move "Offset Crossmember" selector into Weight Storage Extension section when storage = Yes
(function () {
  function initMoveOffsetCrossmember() {
    document.querySelectorAll('.riot-configurator-block[data-block-id]').forEach((block) => {
      const blockId = block.getAttribute('data-block-id');

      // Prevent double-init per block
      if (block.__offsetMoveInit) return;
      block.__offsetMoveInit = true;

      const offsetFieldset = block.querySelector(
        `fieldset.option-selector-${blockId}[data-option-name="offset"]`
      );
      if (!offsetFieldset) return;

      const mainContainer = block.querySelector('.riot-config-options .options-container');
      if (!mainContainer) return;

      // Create placeholders once
      const mainPlaceholder = document.createComment(`offset-placeholder-main-${blockId}`);
      offsetFieldset.parentNode.insertBefore(mainPlaceholder, offsetFieldset);

      // We'll create/insert the storage placeholder lazily when storage UI exists
      const storagePlaceholder = document.createComment(`offset-placeholder-storage-${blockId}`);

      function isStorageYes() {
        const yes = block.querySelector(`#storage-yes-${blockId}`);
        return !!(yes && yes.checked);
      }

      function getStorageContainer() {
        const storageSection = block.querySelector(`#storage-options-${blockId}`);
        return storageSection ? storageSection.querySelector('.options-container') : null;
      }

      function ensureStorageAnchor(storageContainer) {
        if (!storageContainer) return null;

        const pin1 = storageContainer.querySelector(
          `fieldset.option-selector-${blockId}[data-option-name="storage-pin1"]`
        );

        // Insert placeholder above pin1 if we can, otherwise append placeholder to container
        if (pin1?.parentNode && !storagePlaceholder.parentNode) {
          pin1.parentNode.insertBefore(storagePlaceholder, pin1);
        } else if (!storagePlaceholder.parentNode) {
          storageContainer.appendChild(storagePlaceholder);
        }

        return pin1;
      }

      function moveToStorage() {
        const storageContainer = getStorageContainer();
        if (!storageContainer) return;

        ensureStorageAnchor(storageContainer);

        if (storagePlaceholder.parentNode) {
          storagePlaceholder.parentNode.insertBefore(offsetFieldset, storagePlaceholder);
        } else {
          storageContainer.appendChild(offsetFieldset);
        }
      }

      function moveToMain() {
        if (mainPlaceholder.parentNode) {
          mainPlaceholder.parentNode.insertBefore(offsetFieldset, mainPlaceholder);
        } else {
          mainContainer.appendChild(offsetFieldset);
        }
      }

      function apply() {
        if (isStorageYes()) moveToStorage();
        else moveToMain();
      }

      // Listen for storage Yes/No changes (attach once)
      const storageInputs = block.querySelectorAll(
        `input[data-option="storage"][data-block="${blockId}"]`
      );
      storageInputs.forEach((inp) =>
        inp.addEventListener('change', () => setTimeout(apply, 0))
      );

      // Initial placement
      apply();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMoveOffsetCrossmember);
  } else {
    initMoveOffsetCrossmember();
  }
})();
